import clsx from 'clsx';
import Image from 'next/image';

import { Button } from '@/shared';
import {
	Carousel,
	CarouselContent,
	CarouselIndicator,
	CarouselItem,
	CarouselNavigation,
} from '@/shared/ui/carousel';

import { ITextMediaCarousel } from '../../types';

export const TextMediaCarousel = (props: ITextMediaCarousel) => {
	return (
		<div className="space-y-12 xl:space-y-20">
			{props.items.map((item, key) => {
				const className = clsx(
					'flex flex-col items-center gap-8 xl:gap-10 2xl:gap-12',
					{
						'md:flex-row': item.position === 'left',
						'md:flex-row-reverse': item.position === 'right',
					},
				);
				return (
					<div key={key} className={className}>
						<div className="relative w-full shrink-0 md:w-3/5 xl:w-full xl:max-w-3xl 2xl:max-w-4xl">
							<Carousel>
								<CarouselContent>
									{item.media.map((media, key) => {
										if (media.indexOf('kinescope.io') !== -1) {
											return (
												<CarouselItem
													key={key}
													className="relative aspect-video overflow-hidden rounded-xl border-gray-3 bg-gray-4"
												>
													<iframe
														className="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
														src={media}
														loading="lazy"
														allow="autoplay; loop; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write;"
													/>
												</CarouselItem>
											);
										}

										return (
											<CarouselItem
												key={key}
												className="relative aspect-video overflow-hidden rounded-xl border-gray-3 bg-gray-4"
											>
												<Image
													src={media}
													alt={item.title}
													width={900}
													height={520}
													className="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
												/>
											</CarouselItem>
										);
									})}
								</CarouselContent>
								<CarouselNavigation
									className="left-[5%] -mt-3 w-[90%] transition-all group-hover/hover:left-0 group-hover/hover:w-full"
									classNameButton=""
									classNameIcon="size-10"
								/>
								<CarouselIndicator className="relative mt-2 xl:mt-5" />
							</Carousel>
						</div>

						<div className="mx-auto flex max-w-3xl flex-col items-start gap-3">
							<p className="text-base/[1.6] font-semibold text-[#090E1C] xl:text-[32px]/[1.6]">
								{item.title}
							</p>
							{Array.isArray(item.text) ? (
								<ul className="ml-5 list-disc space-y-2 text-base/[1.6] font-semibold text-[#4B5675] xl:text-2xl/[1.6]">
									{item.text.map((text, key) => (
										<li key={key} className="xl:pl-2">
											{text}
										</li>
									))}
								</ul>
							) : (
								<p className="text-base/[1.6] font-semibold text-[#4B5675] xl:text-2xl/[1.6]">
									{item.text}
								</p>
							)}
							{item.action && (
								<Button
									href={item.action.href}
									size="lg"
									variant="plain"
									className="mt-1 text-base/[1.6] font-semibold hover:underline xl:text-xl/[1.6]"
								>
									{item.action.text}
								</Button>
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
};
